/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';

class RelatedFile extends React.Component {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.title = props.title;
    this.href = '/file/' + this.id;
  }

  render() {
    return (
      <div key={this.id}>
        <a href={this.href} target="_blank">{this.title}</a>
      </div>
    );
  }
}

export default RelatedFile;
